<template>
  <div class="application-bar">
    <img class="__logo-big" src="./images/logo-big.png" width="260" height="85" />
    <img class="__logo-small" src="./images/logo-small.png" width="188" height="42" />
    <button type="button" class="btn btn-icon ${menuToggled ? 'active' : ''} __toggle" click.delegate="toggleMenu()">
      <i class="fas fa-bars"></i>
    </button>
  </div>
</template>
